import type { OrderProduct } from "../OrderProduct.js";
import type { ProductForCustomer } from "../Product.js";
import type { ProductAmountPerCategory } from "../ProductAmountPerCategory.js";
import { maxProductQuantityInCart } from "../maxProductQuantityInCart.js";
import { getFreeSlotsForProduct } from "./getFreeSlotsForProduct.js";

export function getOrderProductMaximumQuantity(
	orderProduct: OrderProduct,
	maxProductsPerCategory: ProductAmountPerCategory,
	productsInCart: OrderProduct[],
	productsInOrder: ProductForCustomer[],
	isExpress: boolean,
): number {
	const product = productsInOrder.find(({ id }) => id === orderProduct.product.id);
	if (!product) {
		// In case the product is being removed from order
		return maxProductQuantityInCart;
	}
	const freeSlots = getFreeSlotsForProduct(product, maxProductsPerCategory, productsInCart) + orderProduct.quantity;
	if (isExpress) {
		const warehouseStock = product.warehouseCounts?.[orderProduct.size];
		if (warehouseStock === undefined) {
			return 0;
		}
		return Math.min(warehouseStock, freeSlots);
	}
	return freeSlots;
}
